/**
 * The 36px "×" close control every popup header carries (prototype v3:
 * `aria-label="Cerrar"`, light-gray square button). One component so every
 * `<Modal>` header looks and reads the same. The caller decides what closing
 * means (e.g. the unsaved-changes confirmation), exactly as for Escape.
 */
export function ModalCloseButton({ onClose, disabled }: { onClose: () => void; disabled?: boolean }) {
  return (
    <button type="button" className="v2-modal-v2__close" aria-label="Cerrar" onClick={onClose} disabled={disabled}>
      ×
    </button>
  );
}
